import type { InstallFilters } from "@/store/companyPageStore";
import type { CompanyFilters } from "../types";
import { InclusionMethod } from "@/generated/company-search";

/**
 * Transforms CompanyFilters from Segments to InstallFilters for CompanyDrawer.
 * Excludes products/vendors with NONE_PRESENT (exclusions).
 */
export function toCompanyProfileInstallFilters(
  filters: CompanyFilters | undefined
): InstallFilters {
  if (!filters) {
    return {
      countryAlpha2s: [],
      productAttributeIds: [],
      productIds: [],
      vendorIds: [],
      productCategoryIds: [],
      includeCorporateDescendants: false,
    };
  }

  const productIds = (filters.products || [])
    .filter((p) => p && p.inclusionMethod !== InclusionMethod.NONE_PRESENT)
    .flatMap((p) => p?.ids?.filter((id): id is number => id != null) || []);

  const vendorIds = (filters.vendors || [])
    .filter((v) => v && v.inclusionMethod !== InclusionMethod.NONE_PRESENT)
    .flatMap((v) => v?.ids?.filter((id): id is number => id != null) || []);

  const productAttributeIds = (filters.productAttributes?.ids || []).filter(
    (id): id is number => id != null
  );

  const productCategoryIds = (filters.productCategories?.ids || []).filter(
    (id): id is string => id != null
  );

  const countryAlpha2s = (filters.countryAlpha2s || []).filter(
    (code): code is string => code != null
  );

  return {
    countryAlpha2s,
    productCategoryIds,
    productAttributeIds,
    productIds,
    vendorIds,
    includeCorporateDescendants: false,
  };
}
